ace.define('ace/mode/magpie_highlight_rules', function(require, exports) {
  const oop = require('../lib/oop');
  const TextHighlightRules = require('./text_highlight_rules').TextHighlightRules;

  const MagpieHighlightRules = function() {
    const syntax = ['create', 'describe', 'list', 'alter', 'add', 'drop', 'delete', 'remove',
      'with', 'save', 'set', 'in', 'exists', 'from', 'use', 'between', 'about', 'help',
      'copy', 'recursive', 'script', 'by', 'at'];

    const flow = ['job', 'project', 'task', 'schedule', 'jobs', 'projects', 'tasks', 'schedules',
      'metrics', 'history', 'predecessor', 'start', 'exec', 'execute', 'execution', 'cancel',
      'state', 'none', 'notification', 'subscription', 'subscriptions'];

    const profiling = ['profile'];

    const inference = ['discover', 'relationships'];

    const metadata = ['temp', 'temporary',
      'repository', 'schema', 'table', 'stream', 'sink', 'field', 'data', 'source', 'secret',
      'repositories', 'schemas', 'tables', 'streams', 'sinks', 'fields', 'sources', 'secrets',
      'cascade', 'start', 'stop', 'variables', 'validation', 'suites', 'suite', 'validator',
      'validators', 'private', 'keys'];

    const runtime = ['result', 'show', 'blocking', 'cache', 'uncache', 'print', 'export',
      'partition', 'partitions'];

    const security = ['organization', 'user', 'organizations', 'users', 'password', 'reset', 'role', 'roles',
      'grant', 'revoke', 'usage', 'activity', 'identity', 'provider', 'providers'];

    const sql = [
      'sql', 'select', 'insert', 'update', 'delete', 'from', 'where', 'and', 'or', 'group', 'by',
      'order', 'limit', 'offset', 'having', 'as', 'case', 'then', 'when', 'else', 'end', 'type',
      'left', 'right', 'join', 'on', 'outer', 'desc', 'asc', 'union', 'table', 'primary', 'key',
      'if', 'foreign', 'not', 'references', 'default', 'null', 'inner', 'cross', 'semi', 'anti',
      'natural', 'database', 'using'
    ];

    const sources = [
      'file', 'files', 'path', 'url'
    ];

    const clusters = [
      'cluster', 'clusters', 'bootstrap', 'instance', 'instances', 'type', 'types', 'force',
      'stopped', 'started'
    ];

    const keywords = _.union(
      syntax,
      flow,
      profiling,
      inference,
      metadata,
      runtime,
      security,
      sql,
      sources,
      clusters
    ).join('|');

    const builtinConstants = (
      'true|false'
    );

    const builtinFunctions = (
      'avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|' +
      'coalesce|ifnull|isnull|nvl|regexp_replace|convert|cast'
    );

    const dataTypes = (
      'int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|' +
      'real|number|integer'
    );

    const keywordMapper = this.createKeywordMapper({
      'support.function': builtinFunctions,
      'keyword': keywords,
      'constant.language': builtinConstants,
      'storage.type': dataTypes
    }, 'identifier', true);

    this.$rules = {
      'start': [{
        token: 'comment',
        regex: '//.*$'
      }, {
        token: 'comment',
        start: '/\\*',
        end: '\\*/'
      }, {
        token: 'string',           // ' string
        regex: '\'.*?\''
      }, {
        token: 'string',           // " string
        regex: '".*?"'
      }, {
        token: 'constant.numeric', // float
        regex: '[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b'
      }, {
        token: keywordMapper,
        regex: '[a-zA-Z_$][a-zA-Z0-9_$]*\\b'
      }, {
        token: 'keyword.operator',
        regex: '\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|=|\\*'
      }, {
        token: 'paren.lparen',
        regex: '[\\({]'
      }, {
        token: 'paren.rparen',
        regex: '[\\)}]'
      }, {
        token: 'text',
        regex: '\\s+'
      }],
      'comment': [
        {
          token: 'comment', // closing comment
          regex: '.*?\\*\\/',
          next: 'start'
        }, {
          token: 'comment', // comment spanning whole line
          regex: '.+'
        }
      ]
    };
    this.normalizeRules();
  };

  oop.inherits(MagpieHighlightRules, TextHighlightRules);

  exports.MagpieHighlightRules = MagpieHighlightRules;
});

ace.define('ace/mode/magpie', function(require, exports) {
  const oop = require('../lib/oop');
  const TextMode = require('./text').Mode;
  const MagpieHighlightRules = require('./magpie_highlight_rules').MagpieHighlightRules;

  const Mode = function() {
    this.HighlightRules = MagpieHighlightRules;
  };

  oop.inherits(Mode, TextMode);

  (function() {
    this.lineCommentStart = '//';

    this.$id = 'ace/mode/magpie';
  }).call(Mode.prototype);

  exports.Mode = Mode;
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/magpie-mode.js